import Honeybadger from '@honeybadger-io/js';

function getMeta(name) {
  return document.querySelector(`meta[name="${name}"]`)?.content;
}

if (!window.TMPDisableErrorTracking) {
  Honeybadger.configure({
    api_key: getMeta('honeybadger-key'),
    environment: getMeta('honeybadger-env'),
  });
}
